import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68e1981a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-5" }
const _hoisted_2 = { class: "container p-lg-5 p-3" }
const _hoisted_3 = { class: "fw-bold mb-4 text-center" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = { class: "row mx-0 px-0 d-flex justify-content-center" }
const _hoisted_6 = { class: "col-lg-12 d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()

const transitToTop = () => {
  router.push(`/${route.path?.split('/')[1]}/lobby`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(translate)('SK40leftCommunity')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(translate)('SK42noticeFirst')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(Button, {
            title: _unref(translate)('SK42loginHome'),
            type: 'secondary',
            onClick: transitToTop,
            className: 'fw-bold'
          }, null, 8, ["title"])
        ])
      ])
    ])
  ]))
}
}

})